import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/AuthProvider';
import { badNotification } from '@/components/Notification/Notification';

const ProtectedRoutes = (): JSX.Element => {
  const { token } = useAuth();

  if (!token) {
    badNotification(
      `Relace vypršela`,
      `Relace vypršela, přihlašte se prosím znovu.`
    );
  }

  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
